import { render, staticRenderFns } from "./ProjectSelection.vue?vue&type=template&id=5ff27df1&scoped=true&"
import script from "./ProjectSelection.vue?vue&type=script&lang=ts&"
export * from "./ProjectSelection.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectSelection.vue?vue&type=style&index=0&id=5ff27df1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff27df1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VIcon,VSpacer,VTextField})
